import React, { useEffect, useRef, useState } from 'react';
import styles from './About.module.css';
import Footer from "./Footer";

const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
const aboutBg = `${BASE_URL}/bg-about-2.JPG`;
const aboutImages = [
  { src: `${BASE_URL}/about-1.JPG`, alt: 'About 1', text: 'Blending artistry and precision, I create custom tattoos that reflect each client’s unique story. My Atlanta studio is dedicated to delivering meaningful, one-of-a-kind designs.' },
  { src: `${BASE_URL}/about-2.JPG`, alt: 'About 2', text: 'Recognized as a master in calligraphy tattoos, I specialize in elegant script and black and grey realism. Every piece is crafted with expert attention to detail.' },
  { src: `${BASE_URL}/about-3.JPG`, alt: 'About 3', text: 'With years of experience and a passion for tattooing, I ensure a safe, welcoming environment for every client. Your vision is my inspiration—let’s create lasting art together.' },
];

const About: React.FC = () => {
  const [showArrow, setShowArrow] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const scrollTop = containerRef.current.scrollTop;
      const sectionHeight = containerRef.current.offsetHeight;
      setShowArrow(scrollTop < sectionHeight / 2);
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.aboutPage} style={{overflowY: 'auto', height: '100vh'}}>
      <section className={styles.heroSection} style={{ backgroundImage: `url('${aboutBg}')` }}>
        <div className={styles.heroOverlay}>
          <div className={styles.heroTitle}>ABOUT</div>
        </div>
        {showArrow && (
          <div className={styles.arrowDown} onClick={() => {
            if (containerRef.current) {
              const sections = containerRef.current.querySelectorAll('section');
              if (sections.length > 1) {
                (sections[1] as HTMLElement).scrollIntoView({ behavior: 'smooth' });
              }
            }
          }}>
            <svg width="32" height="32" viewBox="0 0 32 32">
              <polyline points="8,12 16,20 24,12" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" />
            </svg>
          </div>
        )}
      </section>
      <section className={styles.contentSection}>
        <div className={styles.cardsContainer}>
          {aboutImages.map((item, idx) => (
            <div className={styles.card} key={idx}>
              <img src={item.src} alt={item.alt} className={styles.cardImage} />
              <p className={styles.cardText}>{item.text}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About; 